import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class PackageApi extends BaseAPI {
  constructor() {
    super();
  }

  apiName = 'Business';
  controllerName = 'PackageLicenses';
  getList = 'list';

  async getListPackage() {
    let request = {
      url: [this.getAPIUrl(), this.getList].join('/'),
      data: {
        skip: 0,
        take: 1000,
        sort: '',
        filter: '',
        emptyFilter: '',
        columns:
          'package_id,package_code,package_name,price_per_month,price_per_year,fee_initial,extra_pos,extra_tablet,number_of_pos,number_of_tablet,number_of_handheld,national,extra_kiosk',
      },
      isShowLoading: true,
    };
    var res = httpClient.postAsync(request);
    return res;
  }
}

export default new PackageApi();
